module.exports = __webpack_public_path__ + "media/src/images/styleguide/sample_modal_image_2-db3b66ccc3dde3e0584b013bef14f773.png";